import './index.css';
import { CSSProperties, useEffect, useState } from 'react';
import Constants from '../../constants';
import View from '../view';
import React from 'react';
interface Props {
  source?: string;
  style?: CSSProperties | undefined;
  className?: string | undefined;
  placeHolderType?: string | undefined;
}

const Image = ({ source, className, style, placeHolderType = '', ...props }: Props) => {
  const [placeholder, setPlaceHolder] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    switch (placeHolderType) {
      case 'Match':
        setPlaceHolder(Constants.Images.DefaultMatchLogo);
        return;
      case 'Player':
        setPlaceHolder(Constants.Images.DefaultPlayerImage);
        return;
      case 'ContestCategory':
        setPlaceHolder(Constants.Images.DefaultCategoryIcon);
        return;
    }
  }, []);

  const onError = () => {};

  const onLoad = () => {
    setLoading(false);
  };

  return (
    <View
      className={`image-container ${className}`}
      style={{
        backgroundImage: loading ? `url(${placeholder})` : `url(${source})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        ...style
      }}
      {...props}>
      <img style={{ display: 'none' }} src={source} onError={onError} onLoad={onLoad} />
    </View>
  );
};
Image.defaultProps = {
  isNoPlaceHolder: false,
  className: ''
};
export default React.memo(Image);
